import { InformationCircleIcon } from '@heroicons/react/24/outline'

import DetailTemplate from '@/components/DetailTemplate'
import { Input, Textarea, Spinner } from '@/components/ui'
import Address from "@/components/Address"
import { useBienContext } from '../BienContext'
import { formatBienLabel } from '../biensSlice'
import EditButtons from '../EditButtons'
import Form from './Form'

const Detail = () => {
  const { bien, loading,
    updatedSections, markSectionAsUpdated,
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = "info_bien"
  const SECTION_TITLE = "Informations générales"

  const modalContent = <Form />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les informations générales"
  />

  return(
    <DetailTemplate
      sectionId={SECTION_ID}
      title={SECTION_TITLE}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Type de bien" value={bien?.type_bien} valueClassName="capitalize" />
        <Input.Display label="Nombre d'étages" value={bien.nombre_etages} valueClassName="uppercase"/>
        <Input.Display label="Cadastre" value={bien.cadastre} valueClassName="uppercase" />
        <Input.Display label="Date de construction" value={bien.date_construction} />
        <Input.Display label="Adresse" value={bien.ville} forceEmptyPlaceholder={true} className="flex mb-2">
          <Address data={bien} />
        </Input.Display>
      </div>
      <div className="space-y-4">
        <Input.Display label="Bâtiment" value={bien.ref_batiment} valueClassName="uppercase" />
        <Input.Display label="Escalier" value={bien.ref_escalier} valueClassName="uppercase" />
        <Input.Display label="Etage" value={bien.ref_etage} valueClassName="uppercase" />
        <Textarea.Display label="Détails des clés" value={bien.details_cles} className="flex flex-col items-start"/>
      </div>
      <div className="space-y-4">
        <Input.Display label="Codage" value={bien.codage_interne} />
        { bien.type_bien !== 'immeuble' && (
          <>
            <Input.Display label="N° appartement" value={bien.numero_appartement} valueClassName="uppercase" />
            <Input.Display label="N° sonnette" value={bien.numero_sonnette} valueClassName="uppercase" />
            <Input.Display label="N° parking ou box" value={bien.numero_parking} valueClassName="uppercase" />
          </>
        )}

        { ["appartement", "autre"].includes(bien.type_bien) && <>
          {!loading && bien.immeuble && (
            <Input.Display label="Bien rattaché à un immeuble"
              className='flex flex-col items-start'
            >
              <div className="flex items-center">
                <span className="uppercase">
                  {formatBienLabel(bien.immeuble, {withType: false})}
                </span>
                <div className="dropdown dropdown-hover dropdown-end">
                  <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs m-1"><InformationCircleIcon className="size-5" /></div>
                  <div tabIndex={0} className="card dropdown-content w-80 bg-base-100 rounded-box z-1 p-2 shadow-sm">
                    <div tabIndex={0} className="card-body">
                      <h3 className="card-title font-bold text-gray-600 text-sm">Détails sur l'immeuble</h3>

                      <Input.Display label="Adresse" forceEmptyPlaceholder={true}
                        className="flex flex-wrap items-center"
                      >
                        <Address data={bien.immeuble} />
                      </Input.Display>
                    </div>
                    <div className="justify-end card-actions">
                      <a href={`/biens/${bien.immeuble_id}`} className="btn">Voir la fiche</a>
                    </div>
                  </div>
                </div>
              </div>
            </Input.Display>
          )} 
          {!bien.immeuble && (
            <Input.Display label="Bien rattaché à un immeuble">
              { loading && isPendingAction && <Spinner color='primary' size='sm'/>}
            </Input.Display>
          )}
        </>}
      </div>
    </DetailTemplate>
  )
}

export default Detail